import * as React from 'react';

import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  Paper,
  Typography,
} from '@mui/material';

import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import { useGetCabinEventApprovalList } from '../../core/api/hooks/cabin-event';
import useGetAlertFromLocationState from '../../core/api/hooks/common/useGetAlertFromLocationState';

import Alerter from '../../components/Alerter';
import CabinFormsDataGrid from '../../components/CabinFormsDataGrid';
import FormCard from '../../components/FormCard';
import FormPaper from '../../components/FormPaper';
import CabinEventList from './CabinEventList';
import CabinEventDrafts from './CabinEventDrafts';
import { getColor } from '../../core/colors';
import { EventFormStatus } from '../../core/api/clients';

function CabinEventHome() {
  const { metadata, ...roles } = useAuthorizedFormData();

  const { message, isError, title, displayAlert } = useGetAlertFromLocationState();

  if (!metadata) {
    return (
      <Alert severity="error">
        <AlertTitle>Error - Metadata not found</AlertTitle>
      </Alert>
    );
  }

  return (
    <React.Fragment>
      <Alerter
        isError={isError}
        message={message}
        title={title}
        displayAlert={displayAlert}
        vertical="bottom"
        horizontal="left"
      />

      <Collapse in={roles.isContributor}>
        <FormCard
          disableAvatar
          disableLink
          color={metadata.color}
          rootRoute={metadata.route}
          title={metadata.reportType}
        >
          <Box display="flex" flexDirection="column">
            <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
              Your Drafts
            </Typography>
            <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
              <CabinEventDrafts />
            </Paper>
          </Box>
          <Box margin={2} />
          <Box display="flex" flexDirection="column">
            <Typography variant="h6" sx={{ mb: 0, color: getColor(metadata.color)[500], fontWeight: 300 }}>
              Your Submissions
            </Typography>
            <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
              <CabinEventList
                statuses={[EventFormStatus.Submitted]}
                pageSize={25}
                isOwner
              />
            </Paper>
          </Box>
        </FormCard>
      </Collapse>
      <Collapse in={roles.isApprover || roles.isReader || roles.isAdministrator}>
        <FormPaper color={metadata.color}>
          <Box display="flex" alignItems="center" sx={{ mt: 1, mb: 2 }}>
            <Box display="flex" alignItems="center" flexGrow={1}>
              <Typography sx={{ mr: 2 }} variant="h5">
                Cabin Event Forms
              </Typography>
            </Box>
          </Box>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <CabinEventList
              statuses={[EventFormStatus.Submitted, EventFormStatus.Approved, EventFormStatus.Final]}
              pageSize={25}
              readonly={!roles.isApprover}
            />
          </Paper>
        </FormPaper>
      </Collapse>
    </React.Fragment>
  );
}

export default CabinEventHome;
